import DriverDetailsCard from './DriverDetailsCard';
import DriverAvatar from './DriverAvatar';

export {
  DriverDetailsCard,
  DriverAvatar
};



// WEBPACK FOOTER //
// ./src/components/driver/index.js